import { FormControl, FormGroup, Validators } from "@angular/forms";

export interface PaymentForm {
  id: number;
  account_id: number;
  person_id: number;
  realized_at: Date;
  amount: string;
  payment_method: string;
  bank: string;
  vin: string;
  nombre_completo: string;
  car_model: string;
  expected_rent: string;
  user: string;
  initials: string;
  position?: number;
  horas: number;
  dias: number;
  pendiente: boolean;
  status: string;
  pay_parent: number;
  children?: number;
  validate_style: string;
  reviewed?: Date;
  search_control?: string;
  waiting: boolean;
}

export class Payment {
  static asFormGroup(payment: PaymentForm): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(payment.id),
      account_id: new FormControl(payment.account_id),
      person_id: new FormControl(payment.person_id),
      realized_at: new FormControl(payment.realized_at),
      amount: new FormControl(payment.amount),
      payment_method: new FormControl(payment.payment_method),
      bank: new FormControl(payment.bank),
      vin: new FormControl(payment.vin),
      nombre_completo: new FormControl(payment.nombre_completo),
      car_model: new FormControl(payment.car_model),
      expected_rent: new FormControl(payment.expected_rent),
      user: new FormControl(payment.user),
      initials: new FormControl(payment.initials),
      position: new FormControl(payment.position),
      horas: new FormControl(payment.horas),
      dias: new FormControl(payment.dias),
      pendiente: new FormControl(payment.pendiente),
      status: new FormControl(payment.status),
      pay_parent: new FormControl(payment.pay_parent),
      children: new FormControl(payment.children),
      validate_style: new FormControl(payment.validate_style),
      reviewed: new FormControl(payment.reviewed),
      search_control: new FormControl(payment.search_control),
      waiting: new FormControl(payment.waiting),
    });
    return fg;
  }
}
